export default {
    namespaced: true,
    state: {
        message: '',
        type: '',
        timeoutID: undefined,
        showClose: false,
    },
    getters: {
        notification(state) {
            return state;
        }
    },
    mutations: {
        set(state, { message, type, timeoutID }) {
            let validTypes = ['error', 'warning', 'success', 'info'];
            if (!validTypes.includes(type)) {
                throw new Error(`Valid notification types are: ${validTypes.join(', ')}`);
            }

            state.showClose = !timeoutID;
            state.message = message;
            state.type = type;
            state.timeoutID = timeoutID;
        },
        setType(state, type) {
            state.type = type;
        },
    },
    actions: {
        set({ commit, state, dispatch }, { message, type = 'info', timeout = false}) {
            window.clearTimeout(state.timeoutID);
            let timeoutID;
            if (timeout) {
                timeoutID = window.setTimeout(() => dispatch('clear'), timeout);
            }
            commit('set', { message, type, timeoutID });
        },
        clear({ commit, state }) {
            window.clearTimeout(state.timeoutID);
            commit('setType', '');
        },
        success({ dispatch }, message) {
            dispatch('set', { type: 'success', message, timeout: 2500 });
        }
    }
}